import { render } from "./Header.vue?vue&type=template&id=61ec4e1c&scoped=true"
import script from "../js/header.js?vue&type=script&lang=js&external"
export * from "../js/header.js?vue&type=script&lang=js&external"

import "./Header.vue?vue&type=style&index=0&id=61ec4e1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ec4e1c"]])

export default __exports__